import { useSelector } from 'react-redux';
import { selectTranslator, TransFn } from '../redux/features/languages/trans';

/**
 * Return translation function
 */
export function useTrans(): TransFn {
  return useSelector(selectTranslator);
}
